import { createContext, useContext } from 'react';

/**
 * Design choices one version of the intake can override without touching the
 * others: a style sheet for a version, rather than an edit to the components
 * every version shares.
 *
 * Only what has been asked to differ lives here. The components read it with
 * `useIntakeStyle`, and Flow provides the version's own.
 */
export type IntakeStyle = {
  /** Their replies: message bubbles, voice notes and attachments. */
  reply: string;
  /** The text and icons on a reply. */
  replyInk: string;
};

/** The intake as it stands: replies in coral. */
export const INTAKE_STYLE: IntakeStyle = {
  reply: 'custom.coral.400',
  replyInk: 'custom.neutral.50',
};

/**
 * Onboarding 2.0's overrides, from design system comments on 2.0.
 *
 * Replies in a deeper gardenia with charcoal text, 6.2:1: warm like the page
 * but clearly theirs. The coral replies elsewhere carry floral white text at
 * 2.6:1, which fails.
 */
export const ONBOARDING_2_0_STYLE: IntakeStyle = {
  reply: 'custom.gardeniaDark',
  replyInk: 'text.primary',
};

export const IntakeStyleContext = createContext<IntakeStyle>(INTAKE_STYLE);

export const useIntakeStyle = () => useContext(IntakeStyleContext);
